angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/company/:companyOid/alertEmail", {
        template: '<alert-emails-component></alert-emails-component>',
        title: 'alertEmail.TITLE',
        sidebar: 'company'
    }).when("/company/:companyOid/alertEmail/:oid", {
        template: '<alert-email-component></alert-email-component>',
        title: 'alertEmail.TITLE',
        sidebar: 'company'
    });
}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/alert-emails/alert-emails.route.js
// module id = 936
// module chunks = 3